// extracted by mini-css-extract-plugin
export default {"root":"EditUserGroupModal_root__mOGy3","container":"EditUserGroupModal_container__cGPPe"};